import { createFileRoute } from '@tanstack/react-router'
import { NetworkOperationsDashboard } from '@/components/dashboard/NetworkOperationsDashboard'

export const Route = createFileRoute('/_app/share/$token')({
  component: SharedChatPage,
})

function SharedChatPage() {
  return <NetworkOperationsDashboard />
}
